function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  points: "0 3.2 0 11.2 11.2 11.2 11.2 1.8 0 3.2"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "12.8 1.6 12.8 11.2 25.6 11.2 25.6 0 12.8 1.6"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "12.8 12.8 12.8 22.4 25.6 24 25.6 12.8 12.8 12.8"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "0 12.8 0 20.8 11.2 22.2 11.2 12.8 0 12.8"
});

var SvgWindows = function SvgWindows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.6,
    height: 24,
    viewBox: "0 0 25.6 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWindows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/windows.8c67db39.svg";
export { ForwardRef as ReactComponent };